/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {listEscalatedActions} from '../api'

export const useMutationListEscalatedActions = createReactQueryMutationHook('listEscalatedActions', listEscalatedActions)
